export default {"src":"/_next/static/media/trusted.69b77dcf.svg","height":18,"width":15,"blurWidth":0,"blurHeight":0};